/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import CollectionPoolDescriptionHelper from './CollectionPoolDescriptionHelper';
import { createGlobalStyle } from 'styled-components';
import { CollectionPoolApi } from '../../../utils/api';
import { getParamsEnvironment } from '../../../utils/helpers/apiHelper';
import { loaderDataComponent, showTwoDigits } from '../../../utils/helper';
import ErrorParameter from '../../../components/common/ErrorParameter';

function CollectionPoolDescription() {
  const collectionPoolId = window.sessionStorage.getItem('collectionPoolId');
  const [collectionPoolDescription, setCollectionPoolDescription] =
    useState<any>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    // get data for
    // call to api
    getParamsEnvironment(
      CollectionPoolApi.getCollectionPoolDescription(
        collectionPoolId as string,
      ),
      setCollectionPoolDescription,
      setLoading,
      setError,
    );
  }, []);

  const generalInfos = {
    title: 'Informations générales',
    subtitles: {
      STEP: 'NR',
      'Capacité de la STEP': 'NR',
      'Agglomération d’assainissement': 'NR',
      'Réf. Pluviomètre': collectionPoolDescription?.refPluviometre || 'NR', 
      'Ref. Piézomètre': 'NR',
      'Point limite Aval': collectionPoolDescription?.pointLimiteAval || 'NR',
      'Type de BC': collectionPoolDescription?.typeDeBassinDeCollecte || 'NR',
    },
  };
  const structureInfos = {
    title: 'Informations structurelles',
    subtitles: {
      'Nombre de points limites amont':
        collectionPoolDescription?.nombreDePointsLimitesAmont || 'NR',
      'Liste points limites amont':
        collectionPoolDescription?.listePointsLimitesAmont.length > 0
          ? collectionPoolDescription?.listePointsLimitesAmont
          : 'NR',
      'Prise en compte des déversements':
        collectionPoolDescription?.priseEnCompteDesDeversements || 'NR',
      'Nombre de points de déversement':
        collectionPoolDescription?.nombreDePointsDeDeversement || 'NR',
      'Liste DO TP':
        collectionPoolDescription?.listeDOTP.length > 0
          ? collectionPoolDescription?.listeDOTP
          : 'NR',
      'Estimation nb d’abonnés':
        collectionPoolDescription?.estimationDuNombreDAbonnes || 'NR',
    },
  };
  const prInfos = {
    title: window.sessionStorage.getItem('collectionPoolName'),
    subtitles: {
      'Coordonnées du PL':
        collectionPoolDescription?.coordonneesDuPointLimite || 'NR',
      'Nombre de pompes': collectionPoolDescription?.nombreDePompes || 'NR',
      'Débits des pompes':
        collectionPoolDescription?.listeDebitDesPompes.length > 0
          ? collectionPoolDescription?.listeDebitDesPompes
          : 'NR',
      'Longueur de refoulement': 'NR',
      'Diamètre de refoulement': 'NR',
      'Longueur gravitaire du BC': 'NR',
      'Longueur total BC':
        showTwoDigits(
          collectionPoolDescription?.longueurTotaleDuBassinDeCollecte,
        ) + ' ml' || 'NR',
    },
  };
  return (
    <Container className='description_container'>
      <Styles />
      <div style={{ display: 'inline-flex', justifyContent: 'space-evenly' }}>
        <CollectionPoolDescriptionHelper infos={generalInfos} />
        <CollectionPoolDescriptionHelper infos={structureInfos} />
        <CollectionPoolDescriptionHelper infos={prInfos} />
      </div>
      <br/>
      {loaderDataComponent(loading)}
      {error && (
        <ErrorParameter
          message="une erreur s'est produite. Veuillez réessayer"
          title=''
          IsVisible={true}
        />
      )}
    </Container>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
.description_container{
    padding-left: 30px;
    padding-right: 30px;
    flex-direction: column;
    height:100%;
 .container_infos{
  background-color: #F5F8FB;
  border-radius: 15px;
  width: 30%;
  height: 75vh;
   .circle-list{
    height: 80px;
    overflow-y: auto;
    scrollbar-width: thin;
    margin-top: 10px;
   }
   .infos_title{
    margin-top: 15px;
    margin-bottom: 15px;
    font-weight: bold;
    text-align: center;
   }
   .infos_subtitle{
    margin-top: 15px;
   }
   .infos_subtitle_value{
    font-weight: bold;
    margin-top: 15px;
   }
}
   }
}`;
export default CollectionPoolDescription;
